import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, MapPinIcon } from 'lucide-react';
import { purchases, type Purchase } from '../data/purchases';
const MAX_ALERTS = 7;
const VISIBLE_MS = 5200;
const FIRST_DELAY_MS = 6000;
const MIN_GAP_MS = 9000;
const MAX_GAP_MS = 28000;
const randomBetween = (min: number, max: number): number => Math.floor(min + Math.random() * (max - min));
export function PurchaseAlerts() {
  const reduceMotion = useReducedMotion();
  const [current, setCurrent] = useState<Purchase | null>(null);
  const shownRef = useRef<number>(0);
  const poolRef = useRef<Purchase[]>([]);
  useEffect(() => {
    let showTimer = 0;
    let hideTimer = 0;
    const nextPurchase = (): Purchase => {
      if (poolRef.current.length === 0) {
        poolRef.current = [...purchases].sort(() => Math.random() - 0.5);
      }
      return poolRef.current.pop() as Purchase;
    };
    const schedule = (delay: number) => {
      showTimer = window.setTimeout(() => {
        if (shownRef.current >= MAX_ALERTS) return;
        shownRef.current += 1;
        setCurrent(nextPurchase());
        hideTimer = window.setTimeout(() => {
          setCurrent(null);
          if (shownRef.current < MAX_ALERTS) {
            schedule(randomBetween(MIN_GAP_MS, MAX_GAP_MS));
          }
        }, VISIBLE_MS);
      }, delay);
    };
    schedule(FIRST_DELAY_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  return <div className="pointer-events-none fixed right-4 top-4 z-50 w-[19rem] max-w-[calc(100vw-2rem)] sm:right-6 sm:top-6" aria-live="polite" aria-atomic="true" data-id="element-192" data-mp="1ohaslf684k4s">
      <AnimatePresence data-id="element-193" data-mp="1em932i81dg1o">
        {current ? <motion.div key={`${current.firstName}-${shownRef.current}`} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        x: 48
      }} animate={reduceMotion ? {
        opacity: 1
      } : {
        opacity: 1,
        x: 0
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        x: 48
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-start gap-3 rounded-2xl border border-mint-200 bg-white p-4 shadow-lift" data-id="element-194" data-mp="1enaq7l2btszr">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-mint-100 text-mint-700" aria-hidden="true" data-id="element-195" data-mp="2tjbwjtw7vsbn">
              <CheckIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-196" data-mp="3q81l232cnj6l" />
            </span>
            <div className="min-w-0" data-id="element-197" data-mp="3la9rz5pyxr0t">
              <p className="text-sm font-semibold text-ink" data-id="element-198" data-mp="3gj03i8g5otqi">
                {current.firstName} {current.lastName.charAt(0)}.{' '}
                <span className="font-normal text-ink-soft" data-id="element-199" data-mp="3ci7rx8jtacr2">de {current.city}</span>
              </p>
              <p className="mt-0.5 text-sm text-ink-soft" data-id="element-200" data-mp="cu6lv4ei8ael">
                adquirió {current.product}
              </p>
              <p className="mt-1.5 flex items-center gap-1.5 text-xs text-ink-muted" data-id="element-201" data-mp="81n55ykisz5k">
                <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-202" data-mp="1qqznw6wah3gc" />
                {current.time}
              </p>
            </div>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}